module.exports = __webpack_public_path__ + "img/framework.d6d1ef52.png";